import styled from 'styled-components';
import FormForm from './FormForm';

const FormFormStyled = styled(FormForm)``;

export * from './utils';
export default FormFormStyled;
